//dashboard/AccessLogs.jsx


import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  CircularProgress,
} from "@mui/material";
import useAccessLogs from "../../hooks/useAccessLogs";

const AccessLogs = ({ lockId }) => {
  const { logs, loading, error } = useAccessLogs();

  if (loading) return <CircularProgress />;
  if (error) {
    return <Typography color="error">Error loading logs: {error}</Typography>;
  }

  // logs is an object keyed by lockId/deviceId: { "lock123": [...], "lock456": [...], ... }
  // We'll extract only the logs for this particular lockId.
  const lockLogs = logs[lockId] || [];

  // If lockId doesn't exist in logs, means no logs found for that lock.
  if (!lockLogs.length) {
    return (
      <Box>
        <Typography variant="h6" gutterBottom>
          Access Logs for Lock <em>{lockId}</em>
        </Typography>
        <Typography>No logs found for this lock.</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Access Logs for Lock <em>{lockId}</em>
      </Typography>

      <Paper sx={{ padding: "1rem", width: "100%" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Action Type</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lockLogs.map((log) => (
              <TableRow key={log.id}>
                <TableCell>
                  {new Date(log.timestamp).toLocaleString()}
                </TableCell>
                <TableCell>{log.actionType}</TableCell>
                <TableCell>{log.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default AccessLogs;
